import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BackOffice24OrdersEditAdditionalServiceComponent } from '../../back-office24-orders/back-office24-orders-edit-additional-service/back-office24-orders-edit-additional-service.component';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-unplanned-tasks-modal',
  standalone: false,
  templateUrl: './unplanned-tasks-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./unplanned-tasks-modal.component.css']
})
export class UnplannedTasksModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      unplannedTasks: any[],
      organization: any,
      onTaskEdited: () => void
    },
    private dialogRef: MatDialogRef<UnplannedTasksModalComponent>,
    private dialog: MatDialog,
    private backofficeService: BackOfficeService,
    private datepipe: DatePipe
  ) { }

  closeDialog(): void {
    this.dialogRef.close();
  }

  viewTaskDetails(task: any): void {
    if (task && task.orderId) {
      window.open(`admin/back-office24-order/${task.orderId}`, '_blank');
    }
  }

  async editTask(task: any): Promise<void> {
    const swedenTime = new Date().toLocaleString('en-US', { timeZone: 'Europe/Stockholm' });
    const today = new Date(swedenTime);
    const taskFromDate = new Date(task.from);

    const fromDate = taskFromDate < today
      ? this.datepipe.transform(today, 'yyyy-MM-ddTHH:mm:ss')
      : this.datepipe.transform(task.from, 'yyyy-MM-ddTHH:mm:ss');

    const toDate = this.datepipe.transform(task.to, 'yyyy-MM-ddTHH:mm:ss');

    let availableTimeslots = [];
    try {

      let orgId = this.data.organization.organizationId?.toLowerCase();
      if (
        orgId === '3868ef69-054c-40bd-93ae-85cf08e4c71f' || orgId === '2868ef69-054c-40bd-93ae-85cf08e4c71f'
      ) {
        orgId = 'a848ccd3-fd8d-4035-925e-571ebb4e93e8';
      }

      availableTimeslots = await this.backofficeService
        .getAdditionalServicesTimeslots(orgId, fromDate, toDate)
        .toPromise();
    } catch (error) {
      console.error('Error loading timeslots:', error);
    }

    const serviceSlots = availableTimeslots.find(s => s.serviceId === task.additionalServiceId);
    const timeslots = serviceSlots?.slots.filter(slot => slot.capacity > (slot.busy || 0)) || [];
    const availableDates = [...new Set(timeslots.map(slot => slot.localTime.split(' ')[0]))];

    const editDialogRef = this.dialog.open(BackOffice24OrdersEditAdditionalServiceComponent, {
      width: '720px',
      hasBackdrop: true,
      data: {
        additionalService: task,
        status: task.status,
        organization: this.data.organization,
        onlyCalendar: true,
        availableDates: availableDates,
        timeslots: timeslots,
        parkingFrom: task.from,
        parkingTill: task.to
      }
    });

    editDialogRef.afterOpened().subscribe(() => {
      const componentInstance = editDialogRef.componentInstance as BackOffice24OrdersEditAdditionalServiceComponent;
      componentInstance.saveChangesEvent.subscribe(() => {
        if (this.data.onTaskEdited) {
          this.data.onTaskEdited();
        }
      });
    });
  }

  getStatusClass(status: string): string {
    return `status-${(status || 'unknown').toLowerCase()}`;
  }
}
